import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalCreateCriticidad =({languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,severitySelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({level:(editActive)?severitySelected.level:0,name:(editActive)?severitySelected.name:"",description:(editActive)?severitySelected.description:"",icon:(editActive)?severitySelected.icon:0})
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    const levelsActual = dataUsers.data.map(obj => obj.level)
    const iconsActualString = dataUsers.data.map(obj => obj.icon)
    const iconsActual= iconsActualString.map(Number)
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    const dataCriticalities=useFetch('cassia/criticalities','','','GET',server)
    const levels=[
        {
            id:1,
            name:1,
            cassia_criticality_id:1
        },
        {
            id:2,
            name:2,
            cassia_criticality_id:2
        },
        {
            id:3,
            name:3,
            cassia_criticality_id:3
        },
        {
            id:4,
            name:4,
            cassia_criticality_id:4
        },
        {
            id:5,
            name:5,
            cassia_criticality_id:5
        }
    ]
    const iconsSeverity=[
        {
            id:1,
            name:1,
            cassia_criticality_id:1
            // url:'/icon/exit.png'
        },
        {
            id:2,
            name:2,
            cassia_criticality_id:2
        },
        {
            id:3,
            name:3,
            cassia_criticality_id:3
        },
        {
            id:4,
            name:4,
            cassia_criticality_id:4
        },
        {
            id:5,
            name:5,
            cassia_criticality_id:5
        }
    ]
    const filteredIcons = iconsSeverity.filter(icon => !iconsActual.includes(icon.id));
    const filteredLevels = levels.filter(level => !levelsActual.includes(level.id));
    let levelsOptions=filteredLevels
    let iconsOptions=filteredIcons

    // setManttoData({level:filteredLevels[0].id,name:(editActive)?severitySelected.name:"",description:(editActive)?severitySelected.description:"",icon:(editActive)?severitySelected.icon:0})
    if(editActive){
        levelsOptions=[...levelsOptions,{
            id:severitySelected.level,
            name:severitySelected.level,
            cassia_criticality_id:severitySelected.level}
        ]
        if(severitySelected.icon!=0){
            iconsOptions=[...iconsOptions,{
                id:severitySelected.icon,
                name:severitySelected.icon,
                cassia_criticality_id:severitySelected.icon}
            ]
        }
       
        
    }


    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    useEffect(()=>{
     
          if( ManttoData.name=="" || ManttoData.description=="" ){
              setDisabled(true)
          }else{
              setDisabled(false)
          }
    },[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=severitySelected.id
        }

        const body = new URLSearchParams();
        body.append("level",(ManttoData.level==0)?filteredLevels[0].id:ManttoData.level);
        body.append("name",ManttoData.name);
        body.append("description",ManttoData.description);
        body.append("icon",ManttoData.icon);
        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/criticalities/'+url_add, {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               "Content-Type": "application/x-www-form-urlencoded",
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: body,
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setManttoData({level:0,name:"",description:"",icon:0})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
            
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['level']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
    }
    const changeOptionIcon=(option,index)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['icon']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
    }
    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])
    const handleSearchHost=(e)=>{
      
      const term = e.target.value;
      const {name,value}=e.target
      if(name=="ip"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['ip']:value
              }
              
          })
      }
      // console.log(value)
      // setInputIP(value)
      setIpValid(validateIp(value))
      
      const filteredResults = devices.data.hosts.filter((item) => {
          
          return Object.entries(item).some(([key, value]) => {
            if (key === 'ip' || key=== 'Host') {
              return String(value).toLowerCase().includes(term.toLowerCase());
            }
            return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
          });
        });
     
        setResultList(filteredResults)
    }

    //   console.log(resultList)
    const handleSelected=(element)=>{
        setIpValid(validateIp(element.ip))
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['ip']:element.ip
            }
            
        })
        setListSearchIP(false)
    }
    const closeListSearch=()=>{
        setListSearchIP(false)
    }

    const {level,name,description,icon}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar']:lang[languaje]['crear'])+' '+lang[languaje]['severidad']}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    
                                    
                                    
                                    <div className="user-box-GS">
                                    <input required name="name"  type="text" value={name}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])}</label>
                                        
                                    </div>
                                   
                                    <div className="user-box-GS">
                                        {(levelsOptions.length>0)?
                                            
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={'TODOS'}  opt_de={level} origen={'Admin'} data={levelsOptions}   titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>
                                            :'Todos los niveles han sido seleccionados'
                                        }
                                    {/* <input required name="technology"  type="text" value={technology}
                                    onChange={handleChange} />*/}
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['nivel'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    
                                    <div className="user-box-GS">
                                    <input required name="description"  type="text" value={description}
                                    onChange={handleChange} />
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS">
                                        {
                                           
                                            <SelectorIcons placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={'N/A'}  opt_de={icon} origen={'Admin'} data={iconsOptions}   titulo='Severity' selectFunction={changeOptionIcon} index={0}></SelectorIcons>

                                        }
                                    {/* <input required name="technology"  type="text" value={technology}
                                    onChange={handleChange} />*/}
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['icono'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        {
                                            (icon!=0)?<div style={{width:'10%',height:'50%',border:'1px solid grey',borderRadius:'10px',left:'5%',position:'relative',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                            <img src={'/iconos/alerts'+icon+'.svg'} alt={level} style={{ width: 30, height: 30 }} />
                                            </div>:''
                                        }
                                    </div>
                                    
                                    
                                    <div className="user-box-GS">
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateCriticidad